import Util from '../RegistrationUtil'
import Field from '../RegistrationField'
import { getEnv } from 'aria-viewer/utils/environment'

function ZipCode(opts) {
    Field.call(this, opts)

    this.$input = this.$html.find('input')
    this.$city = this.$html.find('.city')

    this._zipCache = {}
}

Util.inherit(ZipCode, Field, {
    getClassName: function() {
        return 'textbox zipcode'
    },

    /* Override due to accesibility requirements */
    _getLableText: function() {
        return '5 digit zip code'
    },

    buildHtml: function() {
        return (
            '' +
            '<input type="text" pattern="[0-9]*" id="' +
            this._getId() +
            '" "' +
            this._getPlaceholderText(true) +
            '"/>' +
            '<div class="city"></div>'
        )
    },

    applyBindings: function() {
        var self = this
        var cache = {}

        this.$input.on('input', function() {
            self._onZipInput($(this).val())
        })

        this.$input.on('change', function() {
            self.setValue($(this).val())
        })
        this.$input.on('focus', this.focus.bind(this))
        this.$input.on('blur', this.blur.bind(this))
    },

    _onZipInput: function(zip) {
        if (zip.length < 5) {
            // zip too short
            this.$city.text('')
        } else if (zip.length > 5) {
            // zip too long
            this.$city.text('Zip code is too long.')
        } else if (this._zipCache[zip]) {
            // zip is cached
            this.$city.text(this._zipCache[zip])
        } else {
            // get city and state from zip
            var self = this
            Util.ajax({
                url: `${getEnv('REACT_APP_BASE_URL')}/tour/registration/ajaxGetCityState`,
                data: { zip: zip },
                success: function(res) {
                    if (res.data) {
                        self._zipCache[zip] = res.data.city + ', ' + res.data.state
                    } else {
                        self._zipCache[zip] = 'Zip code not found.'
                    }
                    self.$city.text(self._zipCache[zip])
                },
            })
        }
    },
})

export default ZipCode
